<template>
    <ul class="menu">
      <li
          v-for="item in filteredMenu"
          :class="[item.additionalClass]"
      >
        <a :href="$getSubdomainLink(item.subdomain, item.route)"
           class="menu__item"
           :class="{
              active: $route.path.includes(item.route),
            }"
        >
          {{ item.name }}
        </a>
      </li>
    </ul>
  </template>
  <script>
    import { useAuthStore, useEnabledStore } from "@/stores";
    export default {
      data() {
        return {
          authStore: useAuthStore(),
          enabledStore: useEnabledStore(),
        };
      },
      computed: {
        menu () {
          return [
            {
              name: 'Inspiration',
              route: '/video/catalog',
              subdomain: 'portal',
              forAuth: false
            },
            {
              name: 'Planner',
              route: '/planner',
              subdomain: 'portal',
              forAuth: false
            }, 
            {
              name: 'Books',
              route: '/books/catalog',
              subdomain: 'portal',
              forAuth: false,
              isPortalTypeBooks: true
            },
            {
              name: 'Blog',
              route: '/blog/catalog',
              subdomain: 'portal',
              forAuth: false
            },
            {
              name: 'Profile',
              route: '/my-profile/personal-info',
              subdomain: 'portal',
              forAuth: true,
              isPortalTypeBooks: true
            },

          ].filter(item => !item.forAuth || this.isAuth)
        },
        filteredMenu() {
          return this.menu.filter(item => {
            if (!this.isAuth && item.forAuth) return false;
  
            if (this.isPortalTypeBooks) {
              return item.isPortalTypeBooks === true;
            }
  
            return true
          });
        },
        isAuth() {
          return this.authStore.isAuth;
        },
        isPortalTypeBooks() {
          return this.enabledStore.portalTypeBooks;
        },
      },
    };
  </script>